import { Lightning, GoogleLogo, Package, Sparkle, ShieldCheck } from "@phosphor-icons/react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";

export default function Login() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.error) {
      toast.error(location.state.error);
    }
  }, [location.state]);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-arena-bg text-arena-text font-mono flex" data-testid="login-page">
      {/* Left: hero */}
      <div className="hidden lg:flex flex-1 flex-col justify-between p-12 relative overflow-hidden border-r border-arena-border">
        <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
        <div className="relative">
          <div className="flex items-center gap-2">
            <Lightning size={22} weight="fill" className="text-arena-primary" />
            <span className="font-heading font-bold tracking-tight">PEP<span className="text-arena-primary">.</span>STYLES</span>
          </div>
        </div>

        <div className="relative">
          <div className="overline mb-3 text-arena-primary">// login required</div>
          <h1 className="font-heading text-6xl font-bold tracking-tighter leading-none">
            YOUR<br/>DROPSHIP<br/><span className="text-arena-primary">COMMAND</span><br/>CENTER
          </h1>
          <p className="text-arena-muted mt-6 max-w-md text-sm leading-relaxed">
            Orders, ads, chatbot, and direct-to-bank Stripe payments — the engine behind
            <span className="text-arena-primary"> pepstyles.store</span>.
          </p>
        </div>

        <div className="relative grid grid-cols-3 gap-4 max-w-lg">
          {[
            { icon: Package, label: "Auto Orders" },
            { icon: Sparkle, label: "AI Ad Forge" },
            { icon: ShieldCheck, label: "Direct-to-Bank" },
          ].map(({ icon: Icon, label }, i) => (
            <div key={i} className="border border-arena-border p-4">
              <Icon size={18} weight="bold" className="text-arena-primary" />
              <div className="text-[10px] tracking-widest uppercase mt-2 text-arena-muted">{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Right: login card */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <Lightning size={22} weight="fill" className="text-arena-primary" />
            <span className="font-heading font-bold tracking-tight">VIRAL<span className="text-arena-primary">.</span>ARENA</span>
          </div>

          <div className="overline mb-2">// sign in</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mb-2">
            ENTER THE <span className="text-arena-primary">ARENA</span>
          </h2>
          <p className="text-arena-muted text-xs mb-8">
            Secure admin access. Only your Google account can unlock the dashboard.
          </p>

          <button
            onClick={handleGoogle}
            data-testid="google-login-btn"
            className="w-full bg-arena-primary text-black px-6 py-4 text-sm tracking-widest uppercase font-bold hover:bg-arena-primaryHover flex items-center justify-center gap-3 group"
          >
            <GoogleLogo size={18} weight="bold" />
            Continue with Google
          </button>

          <div className="mt-6 text-[10px] text-arena-muted tracking-wide leading-relaxed">
            By continuing, you authorize PepStyles HQ to see your Google email &amp; name only.
            No password stored. Session lasts 7 days.
          </div>

          <div className="mt-10 border-t border-arena-border pt-4 flex items-center gap-2 text-[10px] text-arena-muted">
            <ShieldCheck size={12} weight="bold" className="text-arena-success" />
            Powered by Emergent Google Auth
          </div>
        </div>
      </div>
    </div>
  );
}
